<template>
	<v-container class="description none-fluid">
		<banner>{{ banner }}</banner>
		<div class="mx-auto description-content">
			<h3 v-if="title">{{ title }}</h3>
			<br />
			<p v-if="content" v-html="content"></p>
			<br />
			<div v-if="images && images.length === 1">
				<img :src="images[0]" :alt="title" />
			</div>
			<div v-else-if="images && images.length > 1">
				<v-row justify="center">
					<v-col v-for="image in images" :key="image" cols="6">
						<img :src="image" :alt="title" />
					</v-col>
				</v-row>
			</div>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getDescriptionById } from "../../service/outreach";

export default {
	components: {
		Banner
	},
	data() {
		return {
			data: [],
			title: "",
			content: "",
			images: []
		};
	},
	computed: {
		banner() {
			if (this.$route.path.indexOf("/fun/") !== -1) return "Fun";
			else if (this.$route.path.indexOf("/outreach/") !== -1) return "Outreach";
			return "People";
		}
	},
	mounted() {
		const id = this.$route.query.id;
		// check if id is valid
		if (!id) return;

		// determine fun page or outreach page or alumni page
		let url = "";
		if (this.$route.path.indexOf("/fun/") !== -1) url = "fun_page";
		else if (this.$route.path.indexOf("/people/") !== -1) url = "alumni_page";
		else url = "outreach_page";

		getDescriptionById(id, url)
			.then(data => {
				const { title, content, images } = data;
				this.title = title;
				this.content = content;
				this.images = images;
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style lang="scss">
.description {
	.description-content {
		img {
			width: 100%;
			transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
			box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
				0 4px 6px -2px rgba(0, 0, 0, 0.05);

			&:hover {
				transform: scale(1.03);
			}
		}
	}
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.description {
		.description-content {
			img {
				&:hover {
					transform: none;
				}
			}
		}
	}
}
</style>